import { Overlay } from '@EPIC'
import PropTypes from 'prop-types'
import React, { Fragment } from 'react'

import styles from './PageSpinner.styl'

const PageSpinner = ({ show, overlay }) => (
  <Fragment>
    {overlay && <Overlay show={show} />}
    {show && <div className={styles.pageSpinner} />}
  </Fragment>
)

PageSpinner.propTypes = {
  /** Specifies showing Page Spinner */
  show: PropTypes.bool,
  /** Specifies showing Overlay backdrop */
  overlay: PropTypes.bool,
}

PageSpinner.defaultProps = {
  show: false,
  overlay: true,
}

export default PageSpinner
